// extracted by mini-css-extract-plugin
module.exports = {"container":"CrossSellHeader_container__jt3_f","active":"CrossSellHeader_active__xebG8","menuItem":"CrossSellHeader_menuItem__ODzHa"};